window.RCA = window.RCA || {};
window.RCA.login = window.RCA.login || {};
window.RCA.login.Modulsettings = (function () {
    'use strict';

    function Init() {
        $(".qrcode").toggle(window.RCA.shared.AppData.modulsettings.showqrcode);

        if (window.RCA.shared.AppData.modulsettings.showlostpass) {
            $(".lostpass").show();
        } else {
            $(".lostpass").hide();
        }

        if (window.RCA.shared.AppData.modulsettings.floating_login_reg) {
            $("#landing nav").addClass("floating");

            let headerBg = window.RCA.shared.hexToRgb("#FFFFFF");

            if ('floating_login_bg' in window.RCA.shared.AppData.modulsettings) {
                headerBg = window.RCA.shared.hexToRgb(window.RCA.shared.AppData.modulsettings.floating_login_bg);
            }

            let headerOpacity = 1;
            if ('floating_login_opacity' in window.RCA.shared.AppData.modulsettings) {
                headerOpacity = parseInt(window.RCA.shared.AppData.modulsettings.floating_login_opacity) / 100;
            }
            $("#landing nav").css("background-color", 'rgba(' + headerBg.r + ',' + headerBg.g + ',' + headerBg.b + ', '+headerOpacity+')');
            $("#landing nav").css("color", window.RCA.shared.AppData.modulsettings.floating_login_text);
        } else {
            $("#landing nav").removeClass("floating");
            $("#landing nav").css("background-color", "");
            $("#landing nav").css("color", "");
        }

        if (window.RCA.shared.AppData.modulsettings.cdown_showonlogin == false) {
            $("#landing .countdown_bc").hide();
        } else {
            $("#landing .countdown_bc").show();
        }

        window.RCA.shared.showCountDown(window.RCA.shared.AppData.modulsettings.cdown_showonlogin, window.RCA.shared.AppData.modulsettings.cdown_loginpos);

        $("#formLogin").show();
        $("#formReg").hide();
        $("#formLostPass").hide();
        $("#formTwofactor").hide();

        if (window.RCA.shared.AppData.modulsettings.show_login_form) {
            $("#landing nav").show();
        } else {
            $("#landing nav").hide();
        }

        let $layouts = $('main');
        /* Set Title*/
        $layouts.find('.header-primary .data-title').text(window.RCA.shared.AppData.modulsettings.title[window.RCA.shared.localState.lang]);

        /* Set SubTitle */
        $layouts.find('.header-primary .data-subtitle').text(window.RCA.shared.AppData.modulsettings.subTitle[window.RCA.shared.localState.lang]);
    }

    function BuildFromSource() {
        $.post('api/', {
            do: 'getModulSettings'
        }, function (data) {
            window.RCA.shared.AppData.modulsettings = data;
            Init();
            data = null;
        })
    }

    return {
        Init: Init,
        BuildFromSource: BuildFromSource
    }
})();
